import { CustomTableComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { useEapSettingsList } from 'modules/settings/contexts/eap-settings/hooks/use-eap-settings-list.hook';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { EapSettingsRowOptions } from './components/eap-settings-row-options/eap-settings-row-options.component';
import { useDefaultConfigEapSettingsList } from './hooks/use-default-config-eap-setting-list.hook';
import { useDeleteEapSetting } from './hooks/use-delete-eap-setting/use-delete-eap-setting.hook';

export const SettingsDevicesEapSettingsListContainer: React.FC = () => {
    const { t } = useTranslation();
    const {
        configurations,
        isLoading,
        selectedRows,
        handleOnSelectRows,
        handleOnClickRow,
        selectSpecificRows,
        onDeleted,
    } = useEapSettingsList();
    const { getDefaultConfig } = useDefaultConfigEapSettingsList();
    const { openDeleteConfirmation } = useDeleteEapSetting({
        onDeleted,
    });

    return (
        <CustomTableComponent<EapSettings>
            headerTitle={t('settings.devices.eap-settings.eap-config-list.title')}
            loading={isLoading}
            totalElements={configurations.length}
            tableData={configurations}
            selectedRows={selectedRows}
            setSelectedRows={(val) => selectSpecificRows(val as EapSettings[])}
            onSelectRow={(configurationId, event) => handleOnSelectRows(configurationId, event)}
            onClickRow={handleOnClickRow}
            config={getDefaultConfig()}
            horizontalScroll
            emptyMessage={t('settings.devices.eap-settings.eap-config-list.no_config_available')}
            rowOptions={(eapSetting: EapSettings) => [
                <EapSettingsRowOptions
                    key={`eap-settings-row-options-${eapSetting.id}`}
                    eapSetting={eapSetting}
                    onDelete={openDeleteConfirmation}
                />,
            ]}
        />
    );
};
